import React, { useState, useRef, useEffect } from "react";
import { Typography, Button, Box, Tooltip } from "@mui/material";

interface TermoCardProps {
  id: number;
  texto: string;
  onAccept: (id: number) => void;
  aceitos: number[];
}

const TermoCard: React.FC<TermoCardProps> = ({ id, texto, onAccept, aceitos }) => {
  const [scrolled, setScrolled] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const checkIfScrollable = () => {
    const el = scrollRef.current;
    if (el && el.scrollHeight <= el.clientHeight) {
      setScrolled(true);
    }
  };

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setScrolled(true);
    }
  };

  useEffect(() => {
    checkIfScrollable();
  }, [texto]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      bgcolor="white"
      borderRadius="4px"
      boxSizing="border-box"
    >
      <Box
        ref={scrollRef}
        onScroll={handleScroll}
        sx={{
          flex: "1",
          padding: "24px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Typography
          variant="body2"
        >
          <Box
            className="content-termos"
            dangerouslySetInnerHTML={{ __html: texto || "" }}
          />
        </Typography>
      </Box>
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        padding="8px 16px"
        bgcolor="white"
        height="60px"
      >
        {(!scrolled || aceitos.includes(id)) ? (<>
          <Tooltip title="Termo já aceito!" placement="top" arrow>
            <span>
              <Button
                variant="contained"
                color="primary"
                disabled={!scrolled || aceitos.includes(id)}
                onClick={() => onAccept(id)}
              >
                Dar Aceite
              </Button>
            </span>
          </Tooltip>
        </>):(<>
          <Button
            variant="contained"
            color="primary"
            disabled={!scrolled || aceitos.includes(id)}
            onClick={() => onAccept(id)}
          >
            Dar Aceite
          </Button>
        </>)}
      </Box>
    </Box>
  );
};

export default TermoCard;
